// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"30249d3c","977":"24676cd7"}[chunkId] + ".chunk.js";
};